import React, { Component, Fragment } from 'react';
import FormInputText from '../../../_shared/forms/FormInputText';
import FormInputNumber from '../../../_shared/forms/FormInputNumber';

export default class CustomerDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Customer Details</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            classes="form-control"
                            name="customer_id"
                            value={this.props.customer}
                            label="customer"
                            disabled
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}
